import _ from "lodash";

export function checkLimitFile(fileType, allowExcel) {
  const listType = ['doc', 'docx', 'pdf', 'rar', 'zip', 'jpg', 'png'];
  if (allowExcel) {
    return _.includes([...listType, 'xls', 'xlsx',], fileType );
  } 
  return _.includes(listType, fileType);
  }


// WEBPACK FOOTER //
// ./src/constants/checkLimitFile.js